<template>
  <div id="app" class="w-100 h-100 p-3 text-center d-flex flex-column text-uppercase">
    <top-bar class="mb-3" />
    <router-view class="flex-grow-1"/>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import TopBar from '@/components/TopBar.vue'

import './styles/master.scss'

Vue.use(BootstrapVue)
Vue.use(require('vue-moment'));

export default {
  components: {
    TopBar
  }
}
</script>

<style lang="scss"></style>
